import { TypeDefinition } from "../models/generic";

export class CareerCenterJobCategories {
    public static RetinaSpecialist: TypeDefinition = { id: 1, name: "Retina Specialist", sort: 1 };
    public static AlliedHealthProfessional: TypeDefinition = { id: 2, name: "Allied Health Professional", sort: 2 };
    public static AdministrativeStaff: TypeDefinition = { id: 3, name: "Administrative Staff", sort: 3 };

    public static Values: TypeDefinition[] = [
        CareerCenterJobCategories.RetinaSpecialist,
        CareerCenterJobCategories.AlliedHealthProfessional,
        CareerCenterJobCategories.AdministrativeStaff,
    ];
}



// WEBPACK FOOTER //
// ./src/domain/CareerCenterJobCategories.ts